export default __webpack_public_path__ + "static/media/heart_favIcon_active_white.707ea51a.svg";